import create from 'zustand'
import { persist } from 'zustand/middleware'
import { ActualUserFormData, ActualUserStore } from './types'

export const useActualUserStore = create<ActualUserStore>()(
  persist(
    (set, get) => {
      return {
        formData: {
          name: '',
          cpf: '',
          email: '',
          birthDate: '',
          sendingType: '',
          cellphone: '',
          acceptTerm: false,
        },
        setFormData: (formData: Partial<ActualUserFormData>) => {
          set({
            formData: {
              ...get().formData,
              ...formData,
            },
          })
        },
        passwordCreated: null,
        setPasswordCreated: (val: boolean) => {
          set({ passwordCreated: val })
        },
      }
    },
    {
      name: 'actualUser',
      getStorage: () => sessionStorage,
    },
  ),
)
